import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, Sparkles, ArrowRight, X } from "lucide-react";
import { api } from "@/lib/api";

const taskRoutes = {
  invite: "/settings",
  message: "/chat",
  document: "/vault",
  event: "/calendar",
};

export default function OnboardingChecklist() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("onboarding_dismissed") === "1");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/onboarding/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, []);

  if (!status) return null;
  if (status.completed || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem("onboarding_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div data-testid="onboarding-checklist" className="bg-surface border border-brand/30 rounded-3xl p-5 mb-5 animate-fade-up relative">
      <button onClick={dismiss} className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-elevated text-tertiary-fg" aria-label="Chiudi">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-center gap-3 mb-1">
        <div className="w-9 h-9 rounded-2xl bg-brand grid place-items-center">
          <Sparkles className="w-4 h-4 text-white" strokeWidth={1.8} />
        </div>
        <div>
          <h3 className="font-display text-lg font-medium">Configura la tua famiglia</h3>
          <p className="text-xs text-tertiary-fg">Memo AI ti guida nei primi passi</p>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-tertiary-fg mb-1.5">
          <span>Configurazione</span>
          <span className="font-mono text-brand font-medium">{status.progress}%</span>
        </div>
        <div className="h-1.5 rounded-full bg-elevated overflow-hidden">
          <div
            className="h-full bg-brand transition-all duration-500"
            style={{ width: `${status.progress}%` }}
          />
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {status.tasks.map((t) => (
          <button
            key={t.id}
            onClick={() => !t.done && taskRoutes[t.id] && navigate(taskRoutes[t.id])}
            disabled={t.done}
            data-testid={`onboarding-task-${t.id}`}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-left transition-colors ${
              t.done ? "text-tertiary-fg cursor-default" : "hover:bg-elevated text-primary-fg"
            }`}
          >
            {t.done ? (
              <CheckCircle2 className="w-5 h-5 text-sage shrink-0" strokeWidth={1.6} />
            ) : (
              <Circle className="w-5 h-5 text-tertiary-fg shrink-0" strokeWidth={1.4} />
            )}
            <span className={`flex-1 text-sm ${t.done ? "line-through" : ""}`}>{t.label}</span>
            {!t.done && taskRoutes[t.id] && (
              <ArrowRight className="w-4 h-4 text-brand" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
